function isLocalHost(hostname = window.location.hostname) {
  return ['localhost', '127.0.0.1', '', '::1'].includes(hostname)
}

function createLinkConfig () {
  let linkConfig = {
    web: "/",
    h5: "/",
    online: "https://shunlong.s5.udesk.cn/im_client/?web_plugin_id=2664&group_id=1048",
    login: "https://fo.mjgoldfo003.com/Frontoffice/",
    disclaimer: `/singlepage/disclaimer`,
    risk: `/singlepage/risk_disclosure`,
    agreement: `/singlepage/client_agreement`,
    policy: `/singlepage/privacy_policy`,
    ios: "https://apps.apple.com/cn/app/id6745172837",
    android: [
      "https://downloads.akklldownload.com/source/material/MJJY_tuijian.apk",
      "https://mp-18b59665-8ace-4294-a961-e5d5164f6bef.cdn.bspapp.com/GW/2025_6/MJJY_GW_v310.apk"
    ],
    android_backup: 
      "https://mp-18b59665-8ace-4294-a961-e5d5164f6bef.cdn.bspapp.com/GW/2025_6/MJJY_GW_v310.apk",
  };

  /**
   * 本地开发或者UAT 设定:
   * isLocalHost() || window.location.hostname.includes("atbgovernor")
   * 
   * 其余视为正式环境，动态域名
   */
  if (isLocalHost() || window.location.hostname.includes("atbgovernor")) {
    linkConfig.web = "https://meijian.atbgovernor.com";
    linkConfig.h5 = "http://h5-meijian-official.atbgovernor.com/?utm_source=tuijian";
  } else {
    const baseDomain = window.location.hostname.replace(/^[^.]+\./, '');
    linkConfig.h5 = `${window.location.protocol}//h5.${baseDomain}/?utm_source=tuijian`;
  }

  return linkConfig;
}

const sourceUrl = "_s_u_l_";
const linkConfig = createLinkConfig();
const signature = "mjjy";
export { linkConfig, sourceUrl, signature };
